import validateTimeWindow from '../validation/validateTimeWindow'
import validateTimeWindowExceptionDate from '../validation/validateTimeWindowExceptionDate'

import * as OrderTexts from '../../../../../../../../intl'
import type { TimeWindowExceptionValidation } from '../../../../../typings'

export const createValidateTimeWindowExceptions = (
  timeWindowExceptions: Record<string, uui.domain.rm.TimeWindow[]> | undefined,
  workingDayStartSec: number,
  eligibility: uui.domain.server.rm.Eligibility,
  recurrenceDate: uui.domain.YYYYMMDD | undefined,
) => {
  if (timeWindowExceptions) {
    const tweErrors = Object.entries(timeWindowExceptions).reduce(
      (acc: Record<string, TimeWindowExceptionValidation>, [dateAsString, twe]) => {
        const dateError: boolean = !validateTimeWindowExceptionDate(
          dateAsString,
          eligibility,
          recurrenceDate,
        )

        const twErrors: string[] = twe.map((tw: uui.domain.rm.TimeWindow) => {
          const valid: boolean = validateTimeWindow(tw, workingDayStartSec)
          return valid ? '' : OrderTexts.getValidationErrorTimeWindowsValuesText()
        })

        const showTwErrors: boolean = twErrors.some((value: string) => value.length > 0)

        if (dateError || showTwErrors) {
          acc[dateAsString] = {}

          if (dateError) {
            acc[dateAsString].date =
              OrderTexts.getValidationErrorTimeWindowExceptionInvalidDateText()
          }

          if (showTwErrors) {
            acc[dateAsString].timeWindows = twErrors
          }
        }

        return acc
      },
      {},
    )

    const hasErrors = Object.keys(tweErrors).length > 0
    if (hasErrors) {
      return JSON.stringify(tweErrors)
    }
  }
}
